import {
  Component,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  OnInit,
  HostBinding
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { FileItem } from './file-item.interface';

@Component({
  selector: 'suka-file',
  template: `
    <p class="file-filename">{{fileItem.file.name}}</p>
    <span
      *ngIf="fileItem.state === 'edit'"
      class="file__state-container"
      (click)="remove.emit()"
      (keyup.enter)="remove.emit()"
      (keyup.space)="remove.emit()"
      tabindex="0">
      <suka-icon
        *ngIf="isInvalidText"
        icon="alert-circle"
        class="file--invalid">
      </suka-icon>
      <suka-icon
        icon="x"
        class="file-close">
      </suka-icon>
    </span>
    <span *ngIf="fileItem.state === 'upload'">
      <suka-loading size="sm"></suka-loading>
    </span>
    <span
      *ngIf="fileItem.state === 'complete'"
      class="file__state-container"
      tabindex="0">
      <suka-icon
        icon="check"
        class="file-complete">
      </suka-icon>
    </span>
  `
})
export class File {
  /**
   * A single `FileItem` from the set of `FileItem`s
   */
  @Input() fileItem: FileItem;

  @Output() remove = new EventEmitter();

  @HostBinding('class.file__selected-file') selectedFile = true;

  @HostBinding('class.file__selected-file--invalid') get isInvalidText() {
    return this.fileItem.invalidText;
  }

  @HostBinding('class.file__selected-file--valid') get isValid() {
    return this.fileItem.state === 'complete';
  }
}
